<template>
  <div id="content1">
    <div class="container">
      Nuestros productos son desarrollados pensando en la estructura, la
      función, los procesos y el contexto, para satisfacer las necesidades de
      las personas con el más alto estándar de calidad. <br />
      <br />
      Para lograr nuestro objetivo permanentemente:
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
#content1 {
  padding-top: 50px;
  background-color: #ebf5ee;
  font-size: 22px;
  color: #242325;
}
</style>
